<template>
  <div>
    <div class="tuolele-main-box setting-setting">
      <div class="color-black setting-setting-title">
        午托配置
      </div>
      <div class="setting-info">
        <el-form label-width="100px" class="demo-ruleForm">
          <el-form-item label="午托开关">
            <el-switch v-model="company['NOON'].value" />
          </el-form-item>
          <el-form-item label="配置时间">
            <el-time-select
              v-model="company['NOON'].begin_time"
              placeholder="起始时间"
              value-format="HH:mm"
              :picker-options="{
                start: '08:30',
                step: '00:10',
                end: '18:30'
              }"
            />
            <el-time-select
              v-model="company['NOON'].end_time"
              style="margin-left:10px"
              placeholder="结束时间"
              value-format="HH:mm"
              :picker-options="{
                start: '08:30',
                step: '00:10',
                end: '18:30',
                minTime: company['NOON'].begin_time
              }"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitNoon()">提交</el-button>
          </el-form-item>
        </el-form>

      </div>

    </div>
    <div class="tuolele-main-box setting-setting">
      <div class="color-black setting-setting-title">
        日小结
      </div>
      <div class="setting-info">
        <el-form label-width="100px" class="demo-ruleForm">

          <el-form-item label="封面图片">

            <el-upload
              class="cover-uploader"
              accept=".jpg, .png"
              :action="qiniuUrl"
              :data="imageToken"
              :show-file-list="false"
              :on-success="(file) => { handleMainImgSuccess(file) }"
              :before-upload="(file) => { beforeImgUpload(file) }"
            >
              <el-image
                v-if="configReport.value"
                style="width: 100px; height: 100px"
                :src="configReport.value"
                fit="contain"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon" />
            </el-upload>
            <p>点击图片更改 建议分辨率: 750 X 1334 <el-button type="text" @click="openDemo()">案例</el-button></p>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitCover()">设置图片</el-button>
          </el-form-item>
        </el-form>

      </div>
    </div>
  </div>

</template>
<script>

import qiniuUpload from '@/assets/js/upload.js'

export default {
  name: 'CompanySetting',
  components: {},
  data() {
    return {
      company: {
        'NOON': {
          value: '',
          begin_time: '',
          end_time: ''
        }
      },
      configReport: {
        key: 'report_shade_img',
        value: ''
      },
      imageToken: {
        token: '',
        key: ''
      },
      qiniuUrl: qiniuUpload.qiniuUrl,
      userInfo: {}
    }
  },

  mounted() {
    this.userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    this.getCompanySetting()
    this.fnGetNoonTime()
    this.fnGetConfiguration()
    this.imgToken()
  },
  methods: {
    getCompanySetting() {
      this.$http.getCompanySwitch().then((res) => {
        Object.keys(res.data).forEach((ele) => {
          if (this.company.hasOwnProperty(ele)) {
            this.company[ele].value = res.data[ele]
          }
        })
      })
    },
    fnGetConfiguration() {
      this.$http.getConfiguration(this.configReport).then((res) => {
        this.configReport.value = res.data
      })
    },
    openDemo() {
      window.open('https://late-care.tuolele.cn/2021_08_12_wechat_mask_daliy.png', '_blank')
    },
    fnGetNoonTime() {
      this.$http.getNoonTime().then((res) => {
        this.company['NOON'].begin_time = res.data.begin_time
        this.company['NOON'].end_time = res.data.end_time
      })
    },
    async imgToken() {
      const ret = await this.$http.imgToken()
      this.imageToken.token = ret.token
    },
    handleMainImgSuccess(ret) {
      this.configReport.value = qiniuUpload.imgSpace + ret.key
    },
    beforeImgUpload(file) {
      const type = file.name.split('.')[1]
      if (type != 'jpg' && type != 'jpeg' && type != 'png') {
        this.$message({
          type: 'warning',
          message: '文件格式不正确'
        })
        return false
      }
      this.imageToken.key = `reportcover_${this.userInfo.company_id}/${new Date().getTime()}${Math.ceil(Math.random() * 10000)}.${type}`
    },
    submitNoon() {
      if (!this.company['NOON'].begin_time || !this.company['NOON'].end_time) {
        this.$message.error('请选择时间')
        return
      }
      this.$http.setNoonTime(this.company['NOON']).then((res) => {
        this.$message.success('设置成功')
      })
    },
    submitCover() {
      this.$http.setConfiguration(this.configReport).then((res) => {
        this.$message.success('设置成功')
      })
    }

  }
}
</script>
<style lang="scss">
.setting-setting {
  .setting-setting-title {
    font-size: 23px;
  }

  .setting-info {
    margin-top: 20px
  }

}
</style>
